<template>
  <div class="trustpilot-rating mt-1">
    <div class="trustpilot-rating__wrap">
      <div class="trustpilot-rating__imgwrap">
        <a @click.prevent="scrollToTrustpilotReviewsModule" class="trustpilot-rating__logo" href="trustpilot-reviews"><img :src="trustPilotLogo" alt="Trustpilot Logo"></a>
        <img class="trustpilot-rating__stars" :src="trustPilotStarImageUrl" :alt="`${trustPilotStars} Trustpilot Star`">
      </div>
      <div class="trustpilot-rating__bbbwrap">
        <img :src="trustPilotBBBLogo" alt="BBB Accredited Business Logo">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'

const { trustPilotBusinessUnitId, trustPilotApiKey, cdn } = config
export default {
  mounted () {
    // TODO: replace this with hubRequest from utilities.js
    return axios.get(`${process.env.VUE_APP_SERVER}/api/trustpilot/businessunit`, { params: { trustPilotApiKey, trustPilotBusinessUnitId } })
      .then(res => {
        this.trustPilotScore = res.data.score.trustScore
        this.trustPilotStars = res.data.score.stars
        this.trustPilotNumberOfReviews = res.data.numberOfReviews.total
        this.trustPilotDisplayName = res.data.displayName
        // TODO: replace this with hubRequest from utilities.js
        return axios.get(`${process.env.VUE_APP_SERVER}/api/trustpilot/stars_image`, { params: { trustPilotApiKey, stars: this.trustPilotStars } })
          .then(response => {
            this.trustPilotStarImageUrl = response.data.starSvg.url
          })
          .catch(error => {
            console.log('stars error', error)
          })
      })
      .catch(err => {
        console.log('businessunit error', err)
      })
  },
  methods: {
    scrollToTrustpilotReviewsModule () {
      const trustPilotModule = document.querySelector('[data-js-module-name="scms-trustpilot-reviews"]')
      if (trustPilotModule) {
        trustPilotModule.scrollIntoView()
      }
    }
  },
  data () {
    return {
      trustPilotApiKey,
      trustPilotBusinessUnitId,
      trustPilotScore: 0,
      trustPilotStars: 0,
      trustPilotStarImageUrl: '',
      trustPilotNumberOfReviews: 0,
      trustPilotDisplayName: '',
      trustPilotLogo: `${cdn}Trustpilot_Logo_(2022).svg`,
      trustPilotBBBLogo: `${cdn}BBB-Accredited-Logo.svg`
    }
  }
}
</script>
